<template>
  <div class="game-avatar" :class="{ compact }">
    <slot>
      <img
        v-if="img"
        :src="img"
        alt=""
      />
      <div v-else class="absolute inset-0 w-full h-full box-border p-[5px]">
        <div class="w-full h-full bg-[--c-primary-300] text-neutral-700 dark:text-neutral-200 dark:bg-[--c-primary-600] box-border rounded-full flex items-center justify-center font-bold" :class="{ 'text-2xl': !compact }">
          {{ getInitials(alt) }}
        </div>
      </div>
  </slot>

    <div v-if="false" class="absolute top-0 left-0 w-full aspect-square">
      <img class="w-full h-full object-contain" :src="ImgRankAvatar" alt="" />
      <div class="absolute top-[70%] h-[25%] text-center left-0 right-0 font-semibold text-black flex items-center justify-center pt-[0.09rem]" :class="{ 'text-xs': compact, 'pt-[0.4rem]': !compact }">
        {{ rank ? `${rank}º` : '-' }}
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { getInitials } from '@/common/util'

import ImgRankAvatarGold from '@/assets/game/rank-avatar-gold.svg'
import ImgRankAvatarSilver from '@/assets/game/rank-avatar-silver.svg'
import ImgRankAvatarBronze from '@/assets/game/rank-avatar-bronze.svg'
import ImgRankAvatarDefault from '@/assets/game/rank-avatar-default.svg'

const props = defineProps<{
  rank?: number
  compact?: boolean
  img?: string
  alt?: string
}>()

const ImgRankAvatar = computed(() => {
  if (props.rank === 1) return ImgRankAvatarGold
  if (props.rank === 2) return ImgRankAvatarSilver
  if (props.rank === 3) return ImgRankAvatarBronze
  return ImgRankAvatarDefault
})
</script>

<style lang="scss">
.game-avatar {
  @apply relative inline-block min-w-[80px] min-h-[80px];
  &.compact {
    @apply min-w-[48px] min-h-[48px];
  }

  > img {
    @apply absolute h-full w-full scale-[77%] rounded-full object-cover object-top;
  } 
}
</style>